module.exports = __webpack_public_path__ + "files/d1188f0485707dabdbf3b0f14ce7dce6.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-7.png
// module id = 506
// module chunks = 76